/** Older servers omit the capability and must never receive tag_ids. */
export function tagFilterSupported(response: { tag_filter_supported?: boolean }): boolean {
  return response.tag_filter_supported === true;
}
